import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createQueryHook } from '@fourthwall/utils'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useTimelineQuery = createQueryHook(OrderApiClient.getTimeline, {
  queryKey: ['timeline'],
  select: (data) => ({
    ...data,
    events: data.events.map((event) => ({
      ...event,
      description: decodeHtmlEntities(event.description),
    })),
  }),
})
